<template>
    <div class="addr-pdf">
        <div class="addr-pdf__article">
            <div class="header-holder">
                <corpIcon style="max-height: 52px" />
                <p style="display: inline-block; width: 80%" class="addr-pdf__article__text">
                    Отчет по результатам онлайн-проверки адреса на {{ currentDate }}
                </p>
            </div>
        </div>
        <div class="main-info">
            <div class="addr-pdf__header"> 
                <div>ИСХОДНЫЕ ДАННЫЕ</div>
            </div>
            <div class="addr-pdf__source">
                <h3>Адрес: </h3>
                <span>{{ address }}</span>
            </div>
        </div>
        <div class="result">
            <div class="addr-pdf__header">
                <div >РЕЗУЛЬТАТ ПОИСКА</div>
            </div>
            <div class="fl" v-if="isFL">
                <h3>Физические лица:</h3>
                <ul>
                    <li v-for="(fl, i) in data.fl" :key="i">
                        <span>{{ i + 1 }}.</span>{{ fl }}
                    </li>
                </ul>
            </div>
            <div class="ip" v-if="isIP">
                <h3>Индивидуальные предприниматели:</h3>
                <ul>
                    <li v-for="(ip, i) in data.ip" :key="i">
                        <span>{{ i + 1 }}.</span>
                        <a class="tooltip-link" v-if="ip.ogrn" :href="`${window.location.origin}/company/${ip.ogrn}`" target="_blank">{{ ip.name }}</a>
                        <span v-else>{{ ip.name }}</span>
                        <tooltip class="no_print" v-if="ip.ogrn" :ogrn="ip.ogrn"/>
                    </li>
                </ul>
            </div>
            <div class="ul" v-if="isUL">
                <h3>Юридические лица:</h3>
                <ul>
                    <li v-for="(ul, i) in data.ul" :key="i">
                        <span>{{ i + 1 }}.</span>
                        <a class="tooltip-link" v-if="ul.ogrn" :href="`/company/${ul.ogrn}`" target="_blank">{{ ul.name }}</a>
                        <span v-else>{{ ul.name }}</span>
                        <tooltip class="no_print" v-if="ul.ogrn" :ogrn="ul.ogrn"/>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import tooltip from '@/components/ui/tooltip.vue'
import corpIcon from '@/components/ui/corpIcon.vue'

export default {
    props: ['data', 'address', 'date'],
    components: { tooltip, corpIcon },
    computed: {
        currentDate() { return this.date },
        isFL() { return this.data?.fl?.length },
        isIP() { return this.data?.ip?.length },
        isUL() { return this.data?.ul?.length }
    }
}
</script>

<style lang="sass" scoped>
    .addr-pdf
        &__article
            display: flex
            justify-content: flex-start
            align-items: center 
            .header-holder
                width: 100%
                display: flex
                gap: 15px
            border-bottom: 1.5px solid black
            padding: 10px 0
            margin-bottom: 50px
            &__text
                width: 100%
                display: inline-block
                text-align: center
                font-size: 18px
                font-weight: 600
                color: #4771f3
        &__header
            padding: 5px 0
            border-bottom: 1px solid #444
            div
                width: 100%
                max-width: 200px
                line-height: 32px
                text-align: center
                padding: 0 15px
                border-radius: 3px
                font-weight: 500
                background-color: #4770F3
                color: #FEFEFE
                font-size: 14px
        &__source
            padding: 20px 0
            font-weight: 500
            h3
                display: inline
        &__result
            padding: 25px 0
    .ip, .ul, .fl
        padding: 15px 0
        h3
            text-align: left
        ul
            width: 100%
        li
            display: flex
            flex-direction: row
            gap: 5px
</style>